<template lang="pug">
.account-backup
  .row
    .col-12
      p(style='max-width: 750px; margin-top: 10px')
        | {{ $t('pages.backupPage.description') }}
  .row
    .col-12
      ul#my-tab.nav.nav-tabs(role='tablist')
        li.nav-item.active(role='presentation')
          .nav-link.active {{ $t('pages.backupPage.manageBackups') }}

  .row.mt-3(v-if='hasAnyBackup')
    .col-12.col-md-6
      filter-selector(:filters='mountFilterConfig' @update='updateFilter')
    .col-12.col-md-6.text-end
      button.btn.btn-primary.btn--create-backup(@click='createBackup')
        | {{ $t('pages.backupPage.createBackup') }}

  .row(v-if='!hasAnyBackup')
    .col-12.mt-5
      .text-center.mt-5
        img.img-fluid.img(
          src='/img/ilustrations/mailbox-no-contacts.svg'
          style='max-height: 260px'
        )
        p.mt-4
          | {{ $t('message.no_backups') }}
        button.btn.btn-primary.mt-3(@click='createBackup')
          | {{ $t('pages.backupPage.createBackup') }}

  .row(v-else-if='filteredBackup.length === 0')
    .col-12.text-center.mt-5
      p.mt-4 {{ $t('pages.backupPage.noResultsForFilter') }}

  .row(v-else)
    .col-12
      backup-card-table(
        :data='filteredBackup'
        @item-deleted='listBackup'
        @item-edited='listBackup'
      )
      .d-flex.align-items-center.justify-content-end.mt-3
        span.text-muted.me-3(v-if='totalPages') {{ $t('pages.backupPage.pageOf', { current: currentPage, total: totalPages }) }}
        simple-paginator(:payload='backup' @navigate='listBackup')

  create-backup-modal(@refresh='listBackup' ref='createBackupModal')
  backup-in-progress-modal(ref='backupInProgressModal')
</template>

<script>
import CreateBackupModal from '@/modules/account/components/organisms/modals/CreateBackupModal.vue';
import BackupService from '@/modules/account/services/http/BackupService';
import BackupCardTable from '@/modules/account/components/organisms/card-table/BackupCardTable.vue';
import Icon from '@/ui/atoms/Icon.vue';
import BackupInProgressModal from '@/modules/account/components/organisms/modals/BackupInProgressModal.vue';
import BackupState from '@/enums/BackupState';
import FilterSelector from '@/ui/organisms/FilterSelector.vue';
import SimplePaginator from '@/ui/organisms/SimplePaginator.vue';

export default {
  name: 'BackupPage',
  components: {
    CreateBackupModal,
    BackupCardTable,
    Icon,
    BackupInProgressModal,
    FilterSelector,
    SimplePaginator,
  },
  data() {
    return {
      backup: {
        data: [],
        links: {},
        meta: {},
      },
      filters: {
        status: '',
        date_start: '',
        date_end: '',
      },
      hasAnyBackup: false,
      selectedBackup: {},
    };
  },
  async created() {
    this.$store.dispatch('page/setTitle', this.$t('pages.backupPage.title'));
    this.$store.dispatch('page/setHead', this.$t('pages.backupPage.title'));
    await this.listBackup();
    this.hasAnyBackup = this.backup.data.length > 0;
  },
  computed: {
    hasBackupInProgress() {
      return this.backup.data.some((backup) =>
        ['created', 'processing'].includes(backup.status)
      );
    },
    currentPage() {
      return this.backup.meta?.current_page;
    },
    totalPages() {
      return this.backup.meta?.last_page;
    },
    filteredBackup() {
      return this.backup.data.filter((backup) => {
        const createdAt = new Date(backup.created_at);

        const matchesDateStart =
          !this.filters.date_start ||
          createdAt >= new Date(this.filters.date_start);

        const matchesDateEnd =
          !this.filters.date_end ||
          createdAt <= new Date(`${this.filters.date_end}T23:59:59`);

        return matchesDateStart && matchesDateEnd;
      });
    },
    tableHead() {
      return [
        { label: this.$t('backupCardTable.created_at') },
        { label: this.$t('backupCardTable.expired_at') },
        { label: this.$t('backupCardTable.status') },
      ];
    },
    mountFilterConfig() {
      return [
        {
          name: 'status',
          label: this.$t('backupCardTable.status'),
          selected: null,
          options: [
            {
              label: this.$t('modal.inbox_settings_filter.filterAll'),
              value: '',
            },
          ].concat(
            BackupState.values.map((status) => ({
              label: BackupState.getText(status, this.$i18n),
              value: status,
            }))
          ),
        },
      ];
    },
  },
  methods: {
    createBackup() {
      if (this.hasBackupInProgress) {
        const inProgress = this.backup.data.find((backup) =>
          ['created', 'processing'].includes(backup.status)
        );
        this.$refs.backupInProgressModal.open(inProgress);
        return;
      }
      this.$refs.createBackupModal.$refs.modal.open();
    },
    getRouteName() {
      return this.$route.name.split('.').pop();
    },
    isTabActive(type) {
      return this.getRouteName() === type;
    },
    async listBackup(page = 1) {
      this.$loading(true);
      const params = new URLSearchParams({ page });

      if (this.filters.status) {
        params.append('filter[status]', this.filters.status);
      }

      const result = await BackupService.list(params);
      this.backup = result.data;
      this.$loading(false);
    },
    updateFilter(selectedFilters) {
      Object.keys(selectedFilters).forEach((key) => {
        this.filters[key] = selectedFilters[key].value;
      });
      this.listBackup(1);
    },
  },
};
</script>
